import { __assign, __rest } from "tslib";
import React, { forwardRef } from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
export var MenuGroup = forwardRef(function MenuGroup(_a, ref) {
    var title = _a.title, children = _a.children, className = _a.className, props = __rest(_a, ["title", "children", "className"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(React.Fragment, null,
        React.createElement("li", __assign({ ref: ref, className: classNames(classPrefix + "-menu__label", className) }, props),
            React.createElement("a", { className: classPrefix + "-menu__item" },
                React.createElement("div", { className: classPrefix + "-menu__text" }, title))),
        children));
});
MenuGroup.displayName = "MenuGroup";
//# sourceMappingURL=MenuGroup.js.map